// SingleValue is a react-select component responsible to render the option selected
// Some cases require it to look different than the options (see AgentCell)
export const SingleValue = ({ data, ...props }) => (
  <div {...props.innerRef} {...props.innerProps}>
    {data.label}
  </div>
);
